// extracted by mini-css-extract-plugin
var _1 = "NotificationCountBadge-module__animateUploadProgressBarWidth--zK5Fm";
var _2 = "NotificationCountBadge-module__animatedBackground--uArqC";
var _3 = "NotificationCountBadge-module__badge--FOpBL";
var _4 = "NotificationCountBadge-module__doubleDigit--oLRIZ";
var _5 = "NotificationCountBadge-module__one--yWgkS";
var _6 = "NotificationCountBadge-module__singleDigit--aUtft";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badge", _4 as "doubleDigit", _5 as "one", _6 as "singleDigit" }
